import { useState, useEffect } from 'react';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

import KeysTableRow from './KeysTableRow';
import AddCertForm from '../AddCertForm';
import EditCertForm from '../EditCertForm';

import styles from './KeysTable.module.css';
import ListActions from '../../../../common/components/ListActions';
import Modal from '../../../../common/components/Modal';
import {Permission} from "../../../../components/SessionInfo";
import {hetch} from "../../../../utils/fetch.hooked";

const statusesMap = {
  ACTUAL: 'Действует',
  PLANNED: 'Запланирован',
  EXPIRED: 'Истёк срок'
};

function KeysTable({ name, permission }) {
  const [rows, setRows] = useState(null);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [currentKeyInfo, setCurrentKeyInfo] = useState(null);
  const [refetch, setRefetch] = useState(false);

  const handleAddModalClose = () => setAddModalOpen(false);
  const handleEditModalClose = () => setEditModalOpen(false);
  const triggerRefetch = () => setRefetch(refetch => !refetch);

  const handleRemoveRow = (id) => {
    setRows(rows.filter(item => item.key_id !== id));
  };

  useEffect(() => {
    const fetchData = () => {
      hetch(`/api/keys?keyName=${name}`)
        .then(res => res.json())
        .then(res => {
          setRows(res?.content ?? []);
        });
    }
    fetchData();
  }, [name, refetch]);

  return (
    <>
      <div className={styles.actionButtons}>
        <ListActions
          addTitle="Добавить новый УКЭП"
          refreshTitle="Обновить список УКЭП"
          onAddClick={() => setAddModalOpen(true)}
          isRefreshing={!rows}
          onRefreshClick={triggerRefetch}
          permission={permission}
        />
      </div>
      {rows ? (
        <>
          {rows.length ? (
            <TableContainer sx={{width: 'auto'}}>
              <Table sx={{minWidth: 650}}>
                <TableHead>
                  <TableRow>
                    <TableCell>Дата начала действия</TableCell>
                    <TableCell>Дата окончания действия</TableCell>
                    <TableCell>Статус</TableCell>
                    <TableCell>Файл сертификата</TableCell>
                    { permission === Permission.WRITE ? <TableCell></TableCell> : null }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <KeysTableRow
                      key={row.key_id}
                      keyId={row.key_id}
                      keyName={row.key_name}
                      startDate={row.start_date}
                      expireDate={row.expire_date}
                      status={statusesMap[row.state]}
                      setCurrentKeyInfo={setCurrentKeyInfo}
                      setEditModalOpen={setEditModalOpen}
                      handleRemoveRow={handleRemoveRow}
                      permission={permission}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Alert severity="warning">Ключи УКЭП не найдены</Alert>
          )}
        </>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      )}
      <Modal
        header="Добавление сертификата"
        open={addModalOpen}
        onClose={handleAddModalClose}
      >
        <AddCertForm defaultKeyName={name} triggerRefetch={triggerRefetch} handleClose={handleAddModalClose} />
      </Modal>
      <Modal
        header="Редактирование сертификата"
        open={editModalOpen}
        onClose={handleEditModalClose}
      >
        <EditCertForm
          {...currentKeyInfo}
          defaultKeyName={name}
          triggerRefetch={triggerRefetch}
          handleClose={handleEditModalClose}
        />
      </Modal>
    </>
  );
}

export default KeysTable;
